import {mapToCanActivate, Routes} from '@angular/router';
import {ErrorComponent} from './shared/component/error/error.component';
import {AuthComponent} from './shared/component/auth/auth.component';
import {LogoutComponent} from './shared/component/logout/logout.component';
import {ForbiddenComponent} from './shared/component/forbidden/forbidden.component';
import {LoginGuard} from './shared/component/auth/login-guard/LoginGuard';
import {LegalNoticeComponent} from './shared/component/footer/legal-notice/legal-notice.component';
import {ContactComponent} from './shared/component/footer/contact/contact.component';
import {TermsComponent} from './shared/component/footer/terms/terms.component';
import {AuthFailureComponent} from './shared/component/auth/auth-failure.component';
import {BuyerGuard} from './shared/component/auth/buyer-guard/BuyerGuard';
import {DealerSettingsGuard} from './shared/component/auth/dealer-settings-guard/DealerSettingsGuard';
import {UserSettingsComponent} from './shared/component/user-settings/user-settings.component';
import {LandingPageComponent} from './landing-page/landing-page.component';
import {OfferMaintenanceGuard} from './shared/component/auth/offer-maintenance-guard/OfferMaintenanceGuard';
import {NotLockedGuard} from './shared/component/auth/not-locked-guard/NotLockedGuard';
import {DemoComponent} from './shared/misc/demo/demo.component';
import {DevGuard} from './shared/component/auth/dev-guard/DevGuard';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./sales/sales.routes').then(routes => routes.SalesRoutes),
    title: 'UCS - Used Car Sales',
    canActivate: mapToCanActivate([LoginGuard, BuyerGuard])
  },
  {
    path: 'administration',
    loadChildren: () => import('./administration/administration.routes').then(m => m.AdministrationRoutes),
    title: 'UCS - Used Car Sales',
    canActivate: mapToCanActivate([DealerSettingsGuard])
  },
  {
    path: 'maintenance',
    loadChildren: () => import('./maintenance/maintenance.routes').then(routes => routes.MaintenanceRoutes ),
    title: 'UCS - Used Car Sales'
  },
  {
    path: 'maintenance/offer',
    loadChildren: () => import('./maintenance/offer/maintenance-offer.routes').then(routes => routes.MaintenanceOfferRoutes),
    title: 'UCS - Used Car Sales',
    canActivate: mapToCanActivate([LoginGuard, OfferMaintenanceGuard, NotLockedGuard])
  },
  {
    path: 'error',
    component: ErrorComponent,
    title: 'Error'
  },
  {
    path: 'error/:id',
    component: ErrorComponent,
    title: 'Error'
  },
  {
    path: 'landingpage',
    component: LandingPageComponent,
    title: 'UCS - Landing page'
  },
  {
    path: 'logout',
    component: LogoutComponent,
    title: 'UCS - Logout'
  },
  {
    path: 'auth',
    component: AuthComponent,
    title: 'UCS - Authentication'
  },
  {
    path: 'auth/failure',
    component: AuthFailureComponent,
    title: 'Authentication failure'
  },
  {
    path: 'auth/:status',
    component: AuthComponent,
    title: 'Authentication status'
  },
  {
    path: 'auth/success',
    component: AuthComponent,
    title: 'Authentication success'
  },
  {
    path: 'forbidden',
    component: ForbiddenComponent,
    title: 'UCS - Forbidden'
  },
  {
    path: 'terms',
    component: TermsComponent,
    canActivate: mapToCanActivate([LoginGuard]),
    title: 'UCS - Terms'
  },
  {
    path: 'legal-notice',
    component: LegalNoticeComponent,
    canActivate: mapToCanActivate([LoginGuard]),
    title: 'UCS - Legal notice'
  },
  {
    path: 'contact',
    component: ContactComponent,
    canActivate: mapToCanActivate([LoginGuard]),
    title: 'UCS - Contact'
  },
  {
    path: 'user-settings',
    component: UserSettingsComponent,
    canActivate: mapToCanActivate([LoginGuard]),
    title: 'UCS - Used Car Sales'
  },
  {
    path: 'api-gateway',
    loadChildren: () => import('./api-gateway/api-gateway.routes').then(m => m.ApiGatewayRoutes),
    canActivate: mapToCanActivate([DevGuard]),
    title: 'UCS - API Gateway'
  },
  {
    path: 'demo',
    component: DemoComponent,
    canActivate: mapToCanActivate([DevGuard]),
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: 'error/navigation',
    title: 'Error'
  },
];

